import { motion } from "framer-motion";

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

/** Two-column mascot intro strip */
export default function MascotIntro() {
  return (
    <section
      data-testid="mascot-intro"
      className="py-20 md:py-28"
      style={{ background: "var(--surface-secondary)" }}
    >
      <div className="wrap grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeIn}
          className="mx-auto"
        >
          <div
            className="w-[300px] h-[300px] md:w-[340px] md:h-[340px] rounded-[28px] flex items-center justify-center relative overflow-hidden"
            style={{
              background: "#ffffff",
              border: "1px solid var(--border-c)",
              boxShadow: "0 20px 40px -20px rgba(31,74,46,0.35)",
            }}
          >
            <img
              src="/assets/mascot/guides-camp.webp"
              alt="Tommy & Koboi at their campsite with tent, lantern and campfire"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="mt-4 text-center text-xs italic" style={{ color: "var(--on-surface-muted)" }}>
            Tommy &amp; Koboi · your camping guides
          </div>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeIn}
        >
          <div className="eyebrow mb-4">Meet Your Guides</div>
          <h2 className="section-title mb-5">Say hi to Tommy &amp; Koboi.</h2>
          <p className="body-lg max-w-lg">
            Tommy is the seasoned trail explorer with his trusty hiking staff.
            His little brother Koboi tags along with his tiny backpack, ready to
            help you stamp every campsite along the way.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
